import { useForm } from "react-hook-form";
import { v4 as uuid } from "uuid";
import TextInputFormField from "../../components/form-fields/text-input-field/text-input-form-field";
import { ResetPasswordStyled } from "./reset-password.styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { ResetPasswordFormValidation } from "../../utils/validations";
import { Branding } from "../login/login";
import { PrimaryButton } from "../../components/button/button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";
import { resetPasswordApi } from "../../actions";
import { useState } from "react";
import { addNotification } from "../../store/slices/ui-slice";
import { useAppDispatch } from "../../store/hooks";

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isResetting, setIsResetting] = useState(false);
  const [isResetted, setIsResetted] = useState(false);

  const { control, formState, watch } = useForm({
    mode: "all",
    resolver: yupResolver(ResetPasswordFormValidation()),
  });

  const handleOnSubmit = async () => {
    try {
      setIsResetting(true);
      const resp = await resetPasswordApi({ ...watch() });
      console.log({ resp });
      setIsResetted(true);
    } catch (err) {
      console.log(err);
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message:
            "Unable to reset password. Please contact system administrator.",
        })
      );
    } finally {
      setIsResetting(false);
    }
  };
  return (
    <ResetPasswordStyled>
      {isResetted && (
        <Box>
          <Box
            className="back"
            onClick={() => navigate("/login")}
            style={{ marginBottom: "10px" }}
          >
            <ArrowBackIcon fontSize="small" />
            <Typography>Back to Login</Typography>
          </Box>

          <Box className="success">
            <CheckCircleOutlineIcon />
            <Box>
              A password reset link has been sent to your email. Please follow
              the instructions to update your password.
            </Box>
          </Box>
        </Box>
      )}
      {!isResetted && (
        <Box className="container">
          <Box className="form-wrapper">
            <Box className="back" onClick={() => navigate("/login")}>
              <ArrowBackIcon fontSize="small" />
              <Typography>Back to Login</Typography>
            </Box>
            <Box className="title">Reset Your Password</Box>

            <Box className="smallText">
              Are you sure you want to reset your password?
            </Box>

            <Box className="flex">
              <TextInputFormField
                name="email"
                label="Email"
                control={control}
                placeholder="Enter here"
              />
            </Box>

            <Box className="buttons-container">
              <PrimaryButton
                isLoading={isResetting}
                disabled={!formState?.isValid}
                onClick={handleOnSubmit}
              >
                Send Reset Link
              </PrimaryButton>
            </Box>
          </Box>
        </Box>
      )}
      <Branding />
    </ResetPasswordStyled>
  );
};

export default ResetPassword;
